import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useState } from 'react'
import { handleError } from '../utils'
import { handleSuccess } from '../utils'
function Login() {
  const navigate = useNavigate();
  const [loginInfo, setLoginInfo] = useState({
    email: '',
    password: ''
})
const handleChange = (e) => {
   const {id, value} = e.target;
   const copyLoginInfo = {...loginInfo};
   copyLoginInfo[id] = value
   setLoginInfo(copyLoginInfo)
   
}
const handleLogin = async (e) => {
    e.preventDefault();
    const {email, password } = loginInfo;
    if(!email || !password){
        return handleError("Please fill all the fields");
    }
    try{
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      const url = `${baseUrl}/auth/login`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({email, password})
      })
      const result = await response.json();
      console.log("result =>",  result);
      const {success, message, token, name} = result;
      if(success){  
        localStorage.setItem('token',token)
        localStorage.setItem('loggedInUser',name)
        handleSuccess(message);
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      }
      else {
        // Handle validation errors or other errors
        const errorMessage = result.message || result.error?.message || "Signin failed";
        handleError(errorMessage);
      }
    }catch(error){
      handleError("Signin failed");
    }
}
  return (
    <>
    <div className="auth-container"> 
    <h1>Login</h1>
    <form onSubmit={handleLogin}>
        <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" className="form-control" id="email" placeholder="Enter email" value={loginInfo.email} onChange={handleChange} />
        </div>
        <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" className="form-control" id="password" placeholder="Enter password" value={loginInfo.password} onChange={handleChange} />
        </div>
        <button type="submit" className="btn btn-primary">Login</button>
        <span>Don't have an account? <Link to="/signup">Signup</Link></span>
    </form>
    </div>
    <ToastContainer 
      position="top-right" 
      autoClose={5000} 
      hideProgressBar={false} 
      newestOnTop={false} 
      closeOnClick 
      rtl={false} 
      pauseOnFocusLoss 
      draggable 
      pauseOnHover 
      style={{ zIndex: 9999 }}
    />
    </>
  )
}

export default Login